import { TraditionalChapter } from "@/models/chapter.model";
import { LinearPercentages } from "@/models/courses.model";
import { TraditionalRest } from "@/services/rest/traditional.rest";
import { defineStore } from "pinia";
import { instance } from "..";
import { ELoader, useLoaderStore } from "./loader";
import { useMaterialStore } from "./material";
import { useTrailStore } from "./trail";

const store = defineStore({
  id: "chapter",
  state: () => ({
    chapters: [] as TraditionalChapter[],
    currentChapter: null as TraditionalChapter | null,
    percentages: {} as LinearPercentages,
  }),
  getters: {
    currentChapterIndex: (state) => {
      return state.chapters.findIndex(
        (chapter) => chapter.id === state.currentChapter?.id
      );
    },
    isLastChapter(state): boolean {
      return this.currentChapterIndex === state.chapters.length - 1;
    },
  },
  actions: {
    getCourse() {
      const courseId = JSON.parse(String(localStorage.getItem("courseID")));
      const classroomId = localStorage.getItem("classId") ?? undefined;

      useLoaderStore.start(ELoader.CHAPTERS);
      TraditionalRest.getCourseTraditionalById(courseId, {
        classroomId,
      })
        .then(async (response) => {
          this.chapters = response.chapters;
          this.percentages.coursePercentage = response.percentageDone;
          const lastIndex = Math.max(
            response.chapters.findIndex((e) => !e.done),
            0
          );
          await this.selectChapter(lastIndex);
        })
        .finally(() => useLoaderStore.stop(ELoader.CHAPTERS));
    },

    getCoursePercentage() {
      const courseId = JSON.parse(String(localStorage.getItem("courseID")));
      const classroomId = localStorage.getItem("classId") ?? undefined;
      useLoaderStore.start(ELoader.PERCENTAGE);
      TraditionalRest.getPercentages(courseId, { classroomId })
        .then((response) => (this.percentages = response))
        .finally(() => useLoaderStore.stop(ELoader.PERCENTAGE));
    },

    selectChapter(index: number) {
      if (!this.chapters[index]) return;
      const chapter = this.chapters[index];
      this.currentChapter = chapter;

      useLoaderStore.start(ELoader.TRAILS);
      useTrailStore.getTrailsByChapterId(chapter.id, true);
    },

    chapterNext() {
      const advance =
        useMaterialStore.isLastMaterial &&
        useTrailStore.isLastTrail &&
        !this.isLastChapter &&
        this.currentChapter?.done;

      if (advance) this.selectChapter(this.currentChapterIndex + 1);
      return advance;
    },

    chapterPrev() {
      const goBack = this.currentChapterIndex > 0;
      if (goBack) this.selectChapter(this.currentChapterIndex - 1);
      return goBack;
    },
  },
});

export const useChapterStore = store(instance);
